import React from 'react';
import { connect } from 'react-redux';

import { setOnlyAnswer } from '../../../../../../_actions/document-builder.actions';

const QuestionAnswer = ({ item, dispatch, questions }) => {
  const question = questions.find((option) => {
    return option.linkId === item.linkId
  });

  if (!question) {
    return null
  }

  return <div className="form-group">
    <label><strong>Question:</strong></label>

    <div><label>{question.text}</label></div>
    <div className="custom-control custom-switch">
      <input
        onChange={(e) => { dispatch(setOnlyAnswer(e.target.checked)); }}
        id={`id_${item.linkId}_note`}
        checked={item.onlyAnswer ?? false}
        value="note"
        type="checkbox"
        className="custom-control-input" />
      <label
        htmlFor={`id_${item.linkId}_note`}
        className="custom-control-label">Only Answer</label>
    </div>
  </div>
}

const mapStateToProps = state => {
  return {
    questions: state.questionnaire.current.item,
  }
}

export default connect(mapStateToProps)(QuestionAnswer);